/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LocationAreaType {
    URBAN = 'URBAN',
    SUBURBAN = 'SUBURBAN',
    COUNTRYSIDE = 'COUNTRYSIDE',
}
